<template>
    <div v-if="loan">
        <p class="text-center font-normal">
            <template v-if="loan.status === 'current'">
                Remaining balance as of {{ formatDate(loan.principal_date) }}
            </template>
            <template v-else-if="isLoanPaidInFull">
                Paid in full on {{ formatDate(loan.pif_date) }}
            </template>
        </p>

        <h1 class="text-center font-semibold mt-5 mb-8 md:mb-16 md:text-6xl">
            <template v-if="! isLoanActive">
                $0.00
            </template>
            <template v-else-if="displayBalance === null">
                $--.--
            </template>
            <template v-else>
                {{ displayBalance | money(2) }}
            </template>
        </h1>

        <div v-if="isLoanActive" class="w-full h-2 bg-gray-100 rounded-full">
            <div class="bg-action rounded-full h-2" :style="{ 'width': percentOfLoanPaid }"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoanBalance",
    mixins: [
        require('../mixins/InteractsWithLoans').default
    ],

    computed: {
        displayBalance() {
            if (! this.isFunded) {
                return Number(this.loan?.amount ?? 0);
            }

            const balance = Number(this.loan?.balance ?? 0);
            const prepaid = Number(this.loan?.prepaid_amount ?? 0);
            const remaining = balance - prepaid;

            if (Number.isNaN(remaining)) {
                return null;
            }

            return Math.max(0, remaining);
        }
    }
};
</script>
